import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { AppError } from 'src/app/core/errors/http-error/app-error';

@Component({
  selector: 'app-card-error',
  templateUrl: './card-error.component.html',
  styleUrls: ['./card-error.component.scss']
})
export class CardErrorComponent implements OnInit {

  @Input()
  set error(error: AppError) {
    this.data = error;
    this.show = true;
  }

  @Output()
  closed: EventEmitter<any> = new EventEmitter<any>();

  data: AppError;

  show: boolean;

  constructor() { }

  ngOnInit(): void { }

  close() {
    this.show = false;
    this.closed.emit();
  }

}
